var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh24Dp(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5337 8.46682C21.3604 6.29349 18.2804 5.04015 14.8937 5.38682C10.0004 5.88015 5.97369 9.85349 5.42702 14.7468C4.69369 21.2135 9.69369 26.6668 16.0004 26.6668C20.2537 26.6668 23.907 24.1735 25.6137 20.5868C26.0404 19.6935 25.4004 18.6668 24.4137 18.6668C23.9204 18.6668 23.4537 18.9335 23.2404 19.3735C21.7337 22.6135 18.1204 24.6668 14.1737 23.7868C11.2137 23.1335 8.82702 20.7202 8.20035 17.7602C7.08035 12.5868 11.0137 8.00015 16.0004 8.00015C18.2137 8.00015 20.187 8.92015 21.627 10.3735L19.6137 12.3868C18.7737 13.2268 19.3604 14.6668 20.547 14.6668H25.3337C26.067 14.6668 26.667 14.0668 26.667 13.3335V8.54682C26.667 7.36015 25.227 6.76015 24.387 7.60015L23.5337 8.46682V8.46682Z"
  })));
}

export default SvgRefresh24Dp;